import { isAxiosError } from 'axios'
import handleAxiosError from './handle-axios-error'

interface BlobErrorPayload {
  code?: string
  error?: string
}

const ERROR_MESSAGES: Record<string, string> = {
  insufficient_marking_codes:
    'Нет свободных кодов Честного знака для выбранного товара.',
}

export const getBlobErrorMessage = async (error: unknown): Promise<string> => {
  if (!isAxiosError(error) || !(error.response?.data instanceof Blob)) {
    return handleAxiosError(error)
  }

  try {
    const payload = JSON.parse(
      await error.response.data.text(),
    ) as BlobErrorPayload

    return (
      (payload.code && ERROR_MESSAGES[payload.code]) ||
      payload.error ||
      'Не удалось сформировать PDF.'
    )
  } catch {
    return 'Не удалось сформировать PDF.'
  }
}
